__turbopack_context__.v({
  "active": "SelectionSection-module__ERdzaW__active",
  "description": "SelectionSection-module__ERdzaW__description",
  "icon": "SelectionSection-module__ERdzaW__icon",
  "isActionable": "SelectionSection-module__ERdzaW__isActionable",
  "isDisabled": "SelectionSection-module__ERdzaW__isDisabled",
  "optionsContainer": "SelectionSection-module__ERdzaW__optionsContainer",
  "requiredHint": "SelectionSection-module__ERdzaW__requiredHint",
  "sectionRowTitle": "SelectionSection-module__ERdzaW__sectionRowTitle",
  "selectionOptions": "SelectionSection-module__ERdzaW__selectionOptions",
  "selectionSectionWrapper": "SelectionSection-module__ERdzaW__selectionSectionWrapper",
  "text": "SelectionSection-module__ERdzaW__text",
  "title": "SelectionSection-module__ERdzaW__title",
});
